import http from "../../../http-common"
class RegulatoryFocusRFQuarterlyServices {
    getAllRegulatoryFocusRFQuarterlyFocus() {
        return http.get('/regulatory-focus/rf-quarterly')
    }
}

export default new RegulatoryFocusRFQuarterlyServices();